import { TYPES } from './ui.types'

import { getUiInfo } from '../../api/getApi'
import { setUiInfo } from '../../api/patchApi'
import { notify } from '../../helpers/notify'

export const updateUiInfoThunk = () => async (dispatch) => {
  try {
    const response = await getUiInfo()

    dispatch({ type: TYPES.UPDATE_INFO, payload: response })
  } catch (error) {
    notify.errorsList(error.errors)
  }
}

export const setUiPropThunk = (data) => async (dispatch) => {
  try {
    const response = await setUiInfo(data)

    dispatch({ type: TYPES.SET_INFO, payload: response })
  } catch (error) {
    notify.errorsList(error.errors)
  }
}

export const setIsSocketConnectedAction = (status) => ({
  type: TYPES.SET_IS_SOCKET_CONNECTED,
  payload: { status },
})

export const setBottomBarVisibleAction = (isBottomBarVisible) => ({
  type: TYPES.SET_BOTTOM_BAR_VISIBLE,
  payload: { isBottomBarVisible },
})

export const setSurveyStatusAction = (hasSurvey) => ({
  type: TYPES.SET_SURVEY_STATUS,
  payload: { hasSurvey },
})

export const setSurveyDataAction = (surveyData) => ({
  type: TYPES.SET_SURVEY_DATA,
  payload: surveyData,
})

export const clearSurveyState = () => ({ type: TYPES.CLEAR_SURVEY })

export const setBannerStatus = (payload) => ({ type: TYPES.SET_SOCIAL_MEDIA_BANNER_STATUS, payload })
